import { defineMessages } from 'react-intl'

export default defineMessages({
  businessHour: {
    id: 'components.MapCard.businessHour',
    defaultMessage: 'Business hour',
    description: 'Business hour',
  },
})
